
    
    import { lazy } from "react";
    import loadable, { lazy as loadableLazy } from "@modern-js/runtime/loadable"
  
    
    
    import { createShouldRevalidate, handleRouteModule,  handleRouteModuleError} from '@modern-js/runtime/router';
  
    import RootLayout from '@_modern_js_src/routes/layout'
    import loading_0 from '@_modern_js_src/routes/loading';

    import error_0 from '@_modern_js_src/routes/error';

    
    import * as config_0 from "@_modern_js_src/routes/page.config";
import * as config_1 from "@_modern_js_src/routes/__withAuth/layout.config";
import * as config_2 from "@_modern_js_src/routes/__withoutAuth/__showcase/layout.config";
import * as config_3 from "@_modern_js_src/routes/__withoutAuth/authorization/[error$]/page.config";
import * as config_4 from "@_modern_js_src/routes/__withoutAuth/authorization/registrationByGU/page.config";
import * as config_5 from "@_modern_js_src/routes/__withoutAuth/authorization/registrationByPhone/page.config";
import * as config_6 from "@_modern_js_src/routes/__withoutAuth/authorization/layout.config";

    
    if(typeof document !== 'undefined'){
      window._routeModules = {}
    }
  
    
    export const routes = [
  {
  "path": "/",
  "children": [
    {
      "_component": "@_modern_js_src/routes/page",
      "index": true,
      "id": "page",
      "type": "nested",
      "config": config_0,
      "lazyImport": () => import(/* webpackChunkName: "page" */ '@_modern_js_src/routes/page').then(routeModule => handleRouteModule(routeModule, "page")).catch(handleRouteModuleError),
      "component": lazy(() => import(/* webpackChunkName: "page" */ '@_modern_js_src/routes/page').then(routeModule => handleRouteModule(routeModule, "page")).catch(handleRouteModuleError))
    },
    {
      "_component": "@_modern_js_src/routes/$",
      "path": "*",
      "id": "$",
      "type": "nested",
      "lazyImport": () => import(/* webpackChunkName: "$" */ '@_modern_js_src/routes/$').then(routeModule => handleRouteModule(routeModule, "$")).catch(handleRouteModuleError),
      "component": lazy(() => import(/* webpackChunkName: "$" */ '@_modern_js_src/routes/$').then(routeModule => handleRouteModule(routeModule, "$")).catch(handleRouteModuleError))
    },
    {
      "children": [
        {
          "_component": "@_modern_js_src/routes/__withAuth/profile/page",
          "id": "__withAuth/profile/page",
          "type": "nested",
          "path": "profile",
          "lazyImport": () => import(/* webpackChunkName: "__withAuth/profile/page" */ '@_modern_js_src/routes/__withAuth/profile/page').then(routeModule => handleRouteModule(routeModule, "__withAuth/profile/page")).catch(handleRouteModuleError),
          "component": lazy(() => import(/* webpackChunkName: "__withAuth/profile/page" */ '@_modern_js_src/routes/__withAuth/profile/page').then(routeModule => handleRouteModule(routeModule, "__withAuth/profile/page")).catch(handleRouteModuleError))
        }
      ],
      "isRoot": false,
      "config": config_1,
      "_component": "@_modern_js_src/routes/__withAuth/layout",
      "id": "__withAuth/layout",
      "type": "nested",
      "lazyImport": () => import(/* webpackChunkName: "__withAuth/layout" */ '@_modern_js_src/routes/__withAuth/layout').then(routeModule => handleRouteModule(routeModule, "__withAuth/layout")).catch(handleRouteModuleError),
      "component": lazy(() => import(/* webpackChunkName: "__withAuth/layout" */ '@_modern_js_src/routes/__withAuth/layout').then(routeModule => handleRouteModule(routeModule, "__withAuth/layout")).catch(handleRouteModuleError))
    },
    {
      "children": [
        {
          "children": [
            {
              "_component": "@_modern_js_src/routes/__withoutAuth/__showcase/showcase/page",
              "id": "__withoutAuth/__showcase/showcase/page",
              "type": "nested",
              "path": "showcase",
              "lazyImport": () => import(/* webpackChunkName: "__withoutAuth/__showcase/showcase/page" */ '@_modern_js_src/routes/__withoutAuth/__showcase/showcase/page').then(routeModule => handleRouteModule(routeModule, "__withoutAuth/__showcase/showcase/page")).catch(handleRouteModuleError),
              "component": lazy(() => import(/* webpackChunkName: "__withoutAuth/__showcase/showcase/page" */ '@_modern_js_src/routes/__withoutAuth/__showcase/showcase/page').then(routeModule => handleRouteModule(routeModule, "__withoutAuth/__showcase/showcase/page")).catch(handleRouteModuleError))
            }
          ],
          "isRoot": false,
          "config": config_2,
          "id": "__withoutAuth/__showcase/layout",
          "type": "nested",
          "lazyImport": null
        },
        {
          "path": "authorization",
          "children": [
            {
              "_component": "@_modern_js_src/routes/__withoutAuth/authorization/page",
              "index": true,
              "id": "__withoutAuth/authorization/page",
              "type": "nested",
              "lazyImport": () => import(/* webpackChunkName: "__withoutAuth/authorization/page" */ '@_modern_js_src/routes/__withoutAuth/authorization/page').then(routeModule => handleRouteModule(routeModule, "__withoutAuth/authorization/page")).catch(handleRouteModuleError),
              "component": lazy(() => import(/* webpackChunkName: "__withoutAuth/authorization/page" */ '@_modern_js_src/routes/__withoutAuth/authorization/page').then(routeModule => handleRouteModule(routeModule, "__withoutAuth/authorization/page")).catch(handleRouteModuleError))
            },
            {
              "_component": "@_modern_js_src/routes/__withoutAuth/authorization/[error$]/page",
              "id": "__withoutAuth/authorization/(error$)/page",
              "type": "nested",
              "config": config_3,
              "path": ":error?",
              "lazyImport": () => import(/* webpackChunkName: "__withoutAuth/authorization/(error$)/page" */ '@_modern_js_src/routes/__withoutAuth/authorization/[error$]/page').then(routeModule => handleRouteModule(routeModule, "__withoutAuth/authorization/(error$)/page")).catch(handleRouteModuleError),
              "component": lazy(() => import(/* webpackChunkName: "__withoutAuth/authorization/(error$)/page" */ '@_modern_js_src/routes/__withoutAuth/authorization/[error$]/page').then(routeModule => handleRouteModule(routeModule, "__withoutAuth/authorization/(error$)/page")).catch(handleRouteModuleError))
            },
            {
              "_component": "@_modern_js_src/routes/__withoutAuth/authorization/loginByPhone/page",
              "id": "__withoutAuth/authorization/loginByPhone/page",
              "type": "nested",
              "path": "loginByPhone",
              "lazyImport": () => import(/* webpackChunkName: "__withoutAuth/authorization/loginByPhone/page" */ '@_modern_js_src/routes/__withoutAuth/authorization/loginByPhone/page').then(routeModule => handleRouteModule(routeModule, "__withoutAuth/authorization/loginByPhone/page")).catch(handleRouteModuleError),
              "component": lazy(() => import(/* webpackChunkName: "__withoutAuth/authorization/loginByPhone/page" */ '@_modern_js_src/routes/__withoutAuth/authorization/loginByPhone/page').then(routeModule => handleRouteModule(routeModule, "__withoutAuth/authorization/loginByPhone/page")).catch(handleRouteModuleError))
            },
            {
              "_component": "@_modern_js_src/routes/__withoutAuth/authorization/registrationByGU/page",
              "id": "__withoutAuth/authorization/registrationByGU/page",
              "type": "nested",
              "config": config_4,
              "path": "registrationByGU",
              "lazyImport": () => import(/* webpackChunkName: "__withoutAuth/authorization/registrationByGU/page" */ '@_modern_js_src/routes/__withoutAuth/authorization/registrationByGU/page').then(routeModule => handleRouteModule(routeModule, "__withoutAuth/authorization/registrationByGU/page")).catch(handleRouteModuleError),
              "component": lazy(() => import(/* webpackChunkName: "__withoutAuth/authorization/registrationByGU/page" */ '@_modern_js_src/routes/__withoutAuth/authorization/registrationByGU/page').then(routeModule => handleRouteModule(routeModule, "__withoutAuth/authorization/registrationByGU/page")).catch(handleRouteModuleError))
            },
            {
              "_component": "@_modern_js_src/routes/__withoutAuth/authorization/registrationByPhone/page",
              "id": "__withoutAuth/authorization/registrationByPhone/page",
              "type": "nested",
              "config": config_5,
              "path": "registrationByPhone",
              "lazyImport": () => import(/* webpackChunkName: "__withoutAuth/authorization/registrationByPhone/page" */ '@_modern_js_src/routes/__withoutAuth/authorization/registrationByPhone/page').then(routeModule => handleRouteModule(routeModule, "__withoutAuth/authorization/registrationByPhone/page")).catch(handleRouteModuleError),
              "component": lazy(() => import(/* webpackChunkName: "__withoutAuth/authorization/registrationByPhone/page" */ '@_modern_js_src/routes/__withoutAuth/authorization/registrationByPhone/page').then(routeModule => handleRouteModule(routeModule, "__withoutAuth/authorization/registrationByPhone/page")).catch(handleRouteModuleError))
            }
          ],
          "isRoot": false,
          "config": config_6,
          "_component": "@_modern_js_src/routes/__withoutAuth/authorization/layout",
          "id": "__withoutAuth/authorization/layout",
          "type": "nested",
          "lazyImport": () => import(/* webpackChunkName: "__withoutAuth/authorization/layout" */ '@_modern_js_src/routes/__withoutAuth/authorization/layout').then(routeModule => handleRouteModule(routeModule, "__withoutAuth/authorization/layout")).catch(handleRouteModuleError),
          "component": lazy(() => import(/* webpackChunkName: "__withoutAuth/authorization/layout" */ '@_modern_js_src/routes/__withoutAuth/authorization/layout').then(routeModule => handleRouteModule(routeModule, "__withoutAuth/authorization/layout")).catch(handleRouteModuleError))
        }
      ],
      "isRoot": false,
      "_component": "@_modern_js_src/routes/__withoutAuth/layout",
      "id": "__withoutAuth/layout",
      "type": "nested",
      "lazyImport": () => import(/* webpackChunkName: "__withoutAuth/layout" */ '@_modern_js_src/routes/__withoutAuth/layout').then(routeModule => handleRouteModule(routeModule, "__withoutAuth/layout")).catch(handleRouteModuleError),
      "component": lazy(() => import(/* webpackChunkName: "__withoutAuth/layout" */ '@_modern_js_src/routes/__withoutAuth/layout').then(routeModule => handleRouteModule(routeModule, "__withoutAuth/layout")).catch(handleRouteModuleError))
    }
  ],
  "isRoot": true,
  "error": error_0,
  "_component": "@_modern_js_src/routes/layout",
  "loading": loading_0,
  "id": "layout",
  "type": "nested",
  "lazyImport": () => import('@_modern_js_src/routes/layout').then(routeModule => handleRouteModule(routeModule, "layout")).catch(handleRouteModuleError),
  "component": RootLayout
},
];
  